import React from 'react'

const CalibrationServices = () => {
  return (
    <section className="services-details pt-120 pb-120">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="section-title" />
          </div>
          <div className="col-lg-6">
            <div className="section-title" />
          </div>
          {/*Start Services Details Content*/}
          <div className="col-xl-12 col-lg-12">
            <div className="services-details__content">
              <h3>Calibration Services </h3>
              <p className="mb-30">
                Accurate measurement and precise instrumentation are the
                backbone of quality control, safety, and operational efficiency
                across all industries. Calibration Services must ensure that
                instruments, equipment, and measuring devices perform reliably
                and provide consistent, traceable, and correct readings.
              </p>
              <p className="mb-30">
                Calibration standards and procedures were developed to address
                risks such as process errors, safety incidents, product
                non-conformance, and regulatory non-compliance. Without regular
                calibration, companies risk inaccurate measurements, compromised
                quality, increased operational costs, and safety hazards.
              </p>
              <div className="content mt-40">
                <div className="text">
                  <h3 className="mb-4">
                    Purpose and Importance of Calibration Services
                  </h3>
                  <p className="mb-30">
                    The main goal of calibration services is to confirm, adjust,
                    and document the accuracy of measurement instruments.
                    Benefits include:
                  </p>
                  <ul className="project-list">
                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Ensuring instruments measure within specified tolerances
                    </li>

                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Maintaining compliance with international and industry
                      standards
                    </li>

                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Reducing operational errors and improving product quality
                    </li>

                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Extending the lifespan and reliability of equipment
                    </li>

                    <li className="d-flex align-items-center">
                      <i className="icon fa-classic fa-solid fa-check fa-fw" />{" "}
                      Supporting regulatory, ISO, and safety compliance
                    </li>
                  </ul>
                  <p className="mb-30">
                    Regular calibration safeguards production processes ensure
                    traceability, and provide confidence in measurements for
                    engineering, industrial, and laboratory applications.
                  </p>
                </div>
              </div>
              <div className="service-nr-list">
                <h3 className="mb-5">Our Services </h3>
                <p className="mb-30">
                  Pak Arab Inspection LTD. CO Company provides comprehensive calibration
                  services for a wide range of instruments and equipment used in
                  industrial, laboratory, and field applications. Our services
                  are conducted by certified technicians using ultramodern
                  reference standards and traceable calibration procedures.
                </p>
                <p className="mb-30">
                  We offer both on-site and in-lab calibration services,
                  ensuring minimal downtime while keeping high accuracy and
                  compliance.
                </p>
              </div>
              <div className="service-nr-list">
                <h3 className="">Scope </h3>
                <h4 className="">Our Calibration Services typically include</h4>
                <div className="row">
                  <div className="col-lg-4">
                    <h5>Dimensional and Mechanical Instruments</h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Vernier Calipers,
                        Micrometers, and Height Gauges.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Torque Wrenches and
                        Dynamometers.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Slip / Gauge Blocks.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Angle Gauge.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Bench Micrometers.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Bore Gauges.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Cylindrical Blocks.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Angle Plate / Measuring.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Height Gauges.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Caliper Checkers.
                      </li>
                      <li>
                        <i className="fal fa-check" /> Verniers / Digital / Dial
                        Calipers.
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <ul className="outcome-list">
                      <li>
                        <i className="fal fa-check" /> Crimpers.
                      </li>
                      <li>
                        <i className="fal fa-check" /> Depth Micrometers.
                      </li>
                      <li>
                        <i className="fal fa-check" /> Digital / Dial Indicator.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Measuring Tapes.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Length Measurements.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Jigs and Fixtures Length
                        Measurements.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Wire Gauges.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Electronic Gauges.
                      </li>

                      <li>
                        <i className="fal fa-check" /> End Rods / L / S.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Feeler Gauges.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Thread, Ring, and Taper
                        Gauges.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Balances and Weighing
                        Scale.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Radius Gauge.
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <h5>Mechanical</h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Vibration Meters.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Durometers.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Direct Shear Apparatus.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Level Transmitter.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Total Stations.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Tachometer.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Anemometers.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Sound Level Meters.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Centrifuge.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Torque Wrench.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Weighting Balance.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Standard Weighting.
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <h5>Analytical Services </h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> UV-VIS Spectrophotometer.
                      </li>

                      <li>
                        <i className="fal fa-check" /> NIR Spectrophotometer.
                      </li>

                      <li>
                        <i className="fal fa-check" /> FTIR (Fourier Transform
                        Infrared Spectrometer).
                      </li>

                      <li>
                        <i className="fal fa-check" /> FT-NIR (Fourier Transform
                        Near-Infrared Spectrometer).
                      </li>

                      <li>
                        <i className="fal fa-check" /> HPLC with All Detectors.
                      </li>

                      <li>
                        <i className="fal fa-check" /> LC-MS / LC-MS-MS (Liquid
                        Chromatography – Mass Spectrometry).
                      </li>
                      <li>
                        <i className="fal fa-check" /> GC with FID, TCD, FPD
                        Detectors.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Refinery Gas Analyzer
                        (System GC).
                      </li>

                      <li>
                        <i className="fal fa-check" /> Dissolved Gas Analyzer
                        (DGA).
                      </li>
                      <li>
                        <i className="fal fa-check" /> GC-MS with EI, CI, NCI.
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Atomic Absorption
                        Spectrophotometer (Flame & Electrothermal).
                      </li>

                      <li>
                        <i className="fal fa-check" /> ICP-OES (Inductively
                        Coupled Plasma Optical Emission Spectroscopy).
                      </li>

                      <li>
                        <i className="fal fa-check" /> Thermogravimetric
                        Analyzer (TGA).
                      </li>

                      <li>
                        <i className="fal fa-check" /> Differential Scanning
                        Calorimeter (DSC).
                      </li>

                      <li>
                        <i className="fal fa-check" /> X-Ray Diffraction (XRD).
                      </li>

                      <li>
                        <i className="fal fa-check" /> Digital Refractometer.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Total Organic Carbon
                        Analyzer (TOC).
                      </li>

                      <li>
                        <i className="fal fa-check" /> Emission Spectrometer
                        (PDA-Based).
                      </li>

                      <li>
                        <i className="fal fa-check" /> Particle Size Analyzer.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Liquid Particle Counter.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Microscopy (Metallurgical
                        & Stereo).
                      </li>

                      <li>
                        <i className="fal fa-check" /> Cloud Point & Flash Point
                        Apparatus.
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <h5>Chemical Calibration</h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Conductivity Meters.
                      </li>

                      <li>
                        <i className="fal fa-check" /> pH Meters.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Dissolved Oxygen Meters.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Turbidity Meters.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Total Dissolved Oxygen
                        Meters.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Single Gas Detectors.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Multiple Gas Detectors.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Viscosity Meters.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Colorimeter.
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <h5>Mass Calibration </h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Mass Standard Weights.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Weighting Bridges.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Analytical Balances.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Counter Scales.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Mass Comparators.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Micro Balances.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Batching Plants.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Bench / Floor Scale.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Balances.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Weighting Platforms.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Pallet Scales.
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <h5>Time, Frequency and Optic Calibration </h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Atomic Clocks.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Frequency Counters.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Oscilloscopes.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Waveform Generators.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Optical Power Meters.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Fiber Optic Attenuators.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Spectrum Analyzers.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Photometers.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Time Interval Analyzers.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Frequency Standards.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Laser Power Meters.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Transceivers.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Optical Instruments.
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <h5>Thermodynamics</h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Dry Block Calibrator.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Analog & Digital
                        Thermometer.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Drying Oven.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Thermocouples.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Thermocouple Simulator.
                      </li>

                      <li>
                        <i className="fal fa-check" /> RTD Sensor.
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <h5>Humidity Calibration</h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Autoclaves.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Refrigerators & Freezers.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Infrared Thermometers.
                      </li>

                      <li>
                        <i className="fal fa-check" /> RTDs.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Furnace Calibrations.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Temperature Controllers.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Dew Point Meters.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Incubators.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Thermo-hygrometers.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Thermal Imagers.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Ovens.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Data Loggers.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Environmental Chambers.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Hygrometers.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Temperature Transmitter.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Thermocouples.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Temperature / RH Chart
                        Recorders.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Thermometers.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Cold & Freezing Rooms.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Dry Blocks.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Water Baths.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Temperature Water Bath.
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <h5>Electromagnetic</h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Clamp Meters.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Multimeters.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Multi-function Process
                        Calibrator.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Documented Process
                        Calibrator.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Welding Machines.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Earth / Ground Tester.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Ohm Meters.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Decade Resistance Box.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Insulation Testers.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Volt Detectors.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Ammeters.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Power Supplies.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Megohmmeters.
                      </li>

                      <li>
                        <i className="fal fa-check" /> High Voltage Equipment.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Battery Testers.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Static Meters.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Ionizers.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Volt Meter.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Variable Auto
                        Transformers.
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <h5>Apparatus Pressure Calibration</h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Pressure Gauges.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Pressure Transducers.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Compound Gauges.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Pressure Indicators.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Compressors.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Pressure Transmitters.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Pressure Valves.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Pressure Controllers.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Dead Weight Testers.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Vacuum Gauges.
                      </li>

                      <li>
                        <i className="fal fa-check" /> PRV Pressure Relief
                        Valve.
                      </li>

                      <li>
                        <i className="fal fa-check" /> SRV Safety Relief Valve.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Digital Pressure Gauge.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Needle Gauge.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Pressure Switches.
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <h5>Force Calibration</h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Hardness Testers.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Load Cells.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Charpy Impact Testing
                        Machines.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Force Indicators.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Force Gauges.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Force Transducers.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Manual / Hydraulic Torque
                        Wrenches.
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-4">
                    <h5>On- Site Calibration </h5>
                    <ul className="outcome-list mb-5">
                      <li>
                        <i className="fal fa-check" /> Welding Machine.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Transmitter Calibration.
                      </li>

                      <li>
                        <i className="fal fa-check" /> Oven Calibration.
                      </li>
                    </ul>
                  </div>
                </div>
                <div>
                  <h5>Applicable International Standards</h5>
                  <p>
                    All calibration activities are performed following
                    internationally recognized standards and best practices,
                    including:
                  </p>
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="nr-list mb-5">
                        <h4 className="title d-flex align-items-center mb-4">
                          <span>01</span> ISO / IEC Standards
                        </h4>
                        <ul className="outcome-list mb-5">
                          <li>
                            <i className="fal fa-check" /> ISO/IEC 17025.
                          </li>

                          <li>
                            <i className="fal fa-check" /> ISO 9001.
                          </li>

                          <li>
                            <i className="fal fa-check" /> ISO 10012.
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="nr-list mb-5">
                        <h4 className="title d-flex align-items-center mb-4">
                          <span>02</span> ASTM Standards
                        </h4>
                        <ul className="outcome-list mb-5">
                          <li>
                            <i className="fal fa-check" /> ASTM E74.
                          </li>

                          <li>
                            <i className="fal fa-check" /> ASTM E617.
                          </li>

                          <li>
                            <i className="fal fa-check" /> ASTM E2627.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CalibrationServices